/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from "react-redux"
import * as actions from '../../actions/modal'
import Img from "gatsby-image";
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'
import { Carousel } from 'react-responsive-carousel';
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import './style.css';
import Fade from 'react-reveal/Fade'
import Link from "gatsby-link"
import {navigateTo} from "gatsby-link"


const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    desktop:1200,
    large:1400
};
//we use this counter var to read the slide number outside the state
let currNdx = 0;
let prevNdx = 0;

class ProjectListAsync extends Component {

  constructor(props) {
      super(props);
      this.loadProjects = this.loadProjects.bind(this);
      this.componentDidMount = this.componentDidMount.bind(this);
      this.preloadImgs = this.preloadImgs.bind(this);
      this.onLoadImgs = this.onLoadImgs.bind(this);
      this.getCollectionPosFromUrl = this.getCollectionPosFromUrl.bind(this);
      this.goTo = this.goTo.bind(this);
      //this.openDelayed = this.openDelayed.bind(this);


      this.state = {
        projects: null,
      projectsCount: null,
      opacity:0,
      };

  }

  getCollectionPosFromUrl(_hash) {
    var pthSplit = _hash.split('#');
    var slug = pthSplit[1].split('/');
    //pthSplit[2] = parseInt(pthSplit[2])>= 1 ? parseInt(pthSplit[2]) : 1;
  /*  console.log('slug: ');
    console.log(pthSplit);
    console.log(slug);
    console.log(_hash);*/
    var pth = [];
    pth[0] = pthSplit[0];
    pth[1] = slug[1];
    return pth;
  }

  goTo(evt) {
    //console.log(evt.currentTarget.href);
    var pthSplit = this.getCollectionPosFromUrl(evt.currentTarget.href);
    //console.log(pthSplit);
    var pf_id = pthSplit[1];


  this.props.goToProj(pf_id);
  }

  /* openDelayed(id) {
    var t = setTimeout(function(){
      this.props.openWithId(id, 0 );
      clearTimeout(t);
    }.bind(this),600);

  }*/

  loadProjects(projectCat, index) {
    var collection = 'projects';
    var _cat = projectCat;
    if(_cat == 'частные-дoма'){
      _cat = 'private-homes';
    }
    if(_cat == 'бизнес-проекты'){
      _cat = 'business-projects';
    }
    var _json = '/static/'+ collection + '-' + _cat +'-'+this.props._lang+'.json';
     //console.log(projectCat);

    axios.get(_json)
  .then(function (response) {

  this.setState({
    projects: response.data,
    projectsCount:response.data.items.length,
    opacity:1,
    loadedItems: [],
    imageLoadStatus: 'loading',
  });

  var prefix = this.props.screenWidth < breakpoint.mobile ? 'phone-' : '';
  this.preloadImgs(prefix);

  }.bind(this))
  .catch(function (error) {
     console.log(error);
  });

    }

    onLoadImgs(index) {
      if(this.state.loadedItems.length === this.state.projectsCount -1 ){
          this.setState({'imageLoadStatus': 'loaded'});
        //console.log('LOADED');
      }
      //console.log(this.state.loadedItems);
    this.setState(({ loadedItems }) => {
      return { loadedItems: loadedItems.concat(index) }
    })

  }


    preloadImgs(prefix) {
      if(this.state.projects != null){
        this.state.projects.items.map((p, index )=>
      {  var img = document.createElement('img');
        img.src = '/static/' + prefix + p.url; // Assigning the img src immediately requests the image
        //console.log(prefix + p.url); return img;
      }

      )
    }else{
      return;
    }
  }


    componentDidMount() {
      //this.goToNextProj(0);
      this.loadProjects(this.props.projectCat, this.props.img_id);
      //console.log(this.props._lang)
    }

    render() {

      var screenWidth = this.props.screenWidth;
      var screenHeight = this.props.screenHeight;
      var orientation = screenWidth > (screenHeight+  200) ? 'H' : 'V'
      {/* console.log(screenWidth + ' ' + screenHeight + ' ' + orientation) */}


      if(screenWidth < breakpoint.mobile) {
        return (
          <div className={'projList-inner proj-pre' + this.state.imageLoadStatus}>
          { this.state.projects !== null ?
            this.state.projects.items.map((p, index )=>
            <div className={
              'proj-is-' + (this.state.loadedItems.length >= index ? 'loaded' : 'loading')
            }
            key={"d-" + index}
            >
            <Link onClick={(evt)=>this.goTo(evt)} to={p.link}>
            <div className={
              '-' + orientation + ' ' +
              'images-' + this.state.imageLoadStatus +
              ' -' + this.state.loadedItems[index]
            } key={"p-" + index}>

            <img className="sProjectImg" src={'/static/' + p.url}  alt={p.description} onLoad={this.onLoadImgs.bind(this, index)}/>

            </div>

            <h3>
            <span className="proj-name" dangerouslySetInnerHTML={{ __html: p.name }} />
            <hr/>
            <span dangerouslySetInnerHTML={{ __html: p.location }}/>
            </h3>
            </Link>
            </div>
          )
          :
          ''
        }
        </div>
        );
      } else {
        return (

          <div className={'projList-inner proj-pre' + this.state.imageLoadStatus}>
          { this.state.projects !== null ?
            this.state.projects.items.map((p, index )=>
            <div className={
              'proj-is-' + (this.state.loadedItems.length >= index ? 'loaded' : 'loading')
            }
            key={"d-" + index}
            >
            <Link onClick={(evt)=>this.goTo(evt)} to={p.link}>
            <div className={
              '-' + orientation + ' ' +
              'proj-images-' + this.state.imageLoadStatus +
              ' -' + this.state.loadedItems[index]
            } key={"p-" + index}>
            {/* <Link onClick={(evt)=>this.goTo(evt)} to={p.link}>*/}

            <img className="sProjectImg" src={'/static/' + p.url}  alt={p.description} onLoad={this.onLoadImgs.bind(this, index)}/>

            </div>
            <h3>
            <span className="proj-name" dangerouslySetInnerHTML={{ __html: p.name }}/>
            <hr/>
            <span dangerouslySetInnerHTML={{ __html: p.location }}/>
            </h3>
            </Link>
            </div>
          )
          :
          ''
        }
        <span className="closeProjDes" onClick={this.props.closeProjList}><div class="_small gPlus has-text-centered"><span> x Back</span></div></span>
        </div>

        );

        }









  }
}
  ProjectListAsync.propTypes = {
    projectCat: PropTypes.string.isRequired,
    //lang: PropTypes.string.isRequired,
    goToProj: PropTypes.func.isRequired,
    closeProjList: PropTypes.func.isRequired
  };

  const mapStateToProps = ({ modalVisible, openWithId, close, lang, screenWidth, screenHeight }) => {
    return { modalVisible, openWithId, close, lang, screenWidth, screenHeight }
  }

  const mapDispatchToProps = dispatch => {
    return {
      openWithId: (v,i) => dispatch(actions.open_with_id(v,i)),
      close: () => dispatch(actions.close()),
     }
  }

  const ConnectedProjectListAsync = connect(mapStateToProps, mapDispatchToProps)(ProjectListAsync)

  export default ConnectedProjectListAsync



// WEBPACK FOOTER //
// ./src/components/ConnectedProjectListAsync/index.js